/**
 * Route for `student-startup-tier`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { StudentStartupTierPage } from "../features/student-startup-tier/StudentStartupTierPage";

export const studentStartupTierRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/student-startup-tier",
	component: StudentStartupTierPage,
});

export default studentStartupTierRoute;
